import {
  IS_WALTTI_SERVICE_ENVIRONMENT,
  PTA_BANNER_HEIGHT,
  SELECTED_PTA_STORAGE_KEY,
  SEVERITY_LEVELS
} from 'Util/constants'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'
import PublicIcon from '@mui/icons-material/Public'
import { Alert } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect } from 'react'
import { t } from 'ttag'

interface PTABannerProps {
  selectedPta: string
  isGlobalSection?: boolean
}

const StyledBanner = styled(Alert)(() => ({
  height: PTA_BANNER_HEIGHT,
  borderRadius: 0,
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem'
  }
}))

export default function PTABanner({
  selectedPta,
  isGlobalSection = false
}: Readonly<PTABannerProps>) {
  const ALERT_CONFIG = {
    global: {
      icon: PublicIcon,
      severity: SEVERITY_LEVELS.LEARN,
      message: t`Global section for all authorities`
    },
    ptaSpecific: {
      icon: DirectionsBusIcon,
      severity: SEVERITY_LEVELS.INFO,
      message: selectedPta
    }
  } as const
  const config = isGlobalSection ? ALERT_CONFIG.global : ALERT_CONFIG.ptaSpecific
  const IconComponent = config.icon

  // Clear stale PTA selection on global pages
  useEffect(() => {
    if (isGlobalSection && IS_WALTTI_SERVICE_ENVIRONMENT) {
      localStorage.removeItem(SELECTED_PTA_STORAGE_KEY)
    }
  }, [isGlobalSection])

  return (
    <StyledBanner
      icon={<IconComponent />}
      severity={config.severity}
      elevation={0}
      variant="filled"
    >
      {config.message}
    </StyledBanner>
  )
}
